import React from 'react';
import { fc, ord, MOS } from '../../utils';

/**
 * BillCalendarCard — monthly bill calendar grid + upcoming bill chips.
 * Pure display; receives bills, paid status, and current date context.
 */
export function BillCalendarCard({ allBills, paidToday, now }) {
  const today = now.getDate();
  const calDays = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
  const calStart = new Date(now.getFullYear(), now.getMonth(), 1).getDay();

  const billsByDay = {};
  allBills.forEach((b) => {
    if (!billsByDay[b.due]) billsByDay[b.due] = [];
    billsByDay[b.due].push(b);
  });

  return (
    <div className="card cp" style={{ marginBottom: 12 }}>
      <div className="st">
        📅 Bill Calendar — {MOS[now.getMonth()]} {now.getFullYear()}
      </div>

      <div
        style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 2, marginBottom: 8 }}
      >
        {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map((d) => (
          <div
            key={d}
            style={{
              textAlign: 'center',
              fontSize: 9,
              fontWeight: 700,
              color: 'var(--mut)',
              padding: '3px 0',
            }}
          >
            {d}
          </div>
        ))}
        {Array.from({ length: calStart + calDays }, (_, i) => {
          const day = i < calStart ? null : i - calStart + 1;
          const dayBills = day ? billsByDay[day] || [] : [];
          const isToday = day === today;

          return (
            <div
              key={i}
              style={{
                minHeight: 34,
                padding: '3px 2px',
                borderRadius: 5,
                textAlign: 'center',
                background: isToday
                  ? 'rgba(255,217,61,.12)'
                  : dayBills.length
                    ? 'var(--surf2)'
                    : 'transparent',
                border: isToday ? '1px solid rgba(255,217,61,.4)' : '1px solid transparent',
              }}
            >
              {day && (
                <div
                  style={{
                    fontSize: 9,
                    lineHeight: 1.2,
                    color: isToday ? 'var(--ylw)' : 'var(--mut)',
                    fontWeight: isToday ? 700 : 400,
                  }}
                >
                  {day}
                </div>
              )}
              {dayBills.map((b) => (
                <div
                  key={b.id}
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    background: paidToday[b.id] ? 'var(--grn)' : b.col,
                    margin: '2px auto',
                    opacity: paidToday[b.id] ? 0.5 : 1,
                  }}
                />
              ))}
            </div>
          );
        })}
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 4 }}>
        {allBills
          .filter((b) => b.due >= today && b.due <= today + 14)
          .sort((a, b) => a.due - b.due)
          .map((b) => (
            <span
              key={b.id}
              style={{
                fontSize: 9,
                padding: '2px 7px',
                borderRadius: 99,
                background: 'var(--surf2)',
                border: '1px solid ' + (paidToday[b.id] ? 'var(--grn)' : b.col),
                color: paidToday[b.id] ? 'var(--grn)' : b.col,
                fontWeight: 700,
              }}
            >
              {ord(b.due)} {b.name} {fc(b.amt)} {paidToday[b.id] ? '✓' : ''}
            </span>
          ))}
      </div>
    </div>
  );
}
